.sellalong-discount {
  text-decoration: line-through;
  text-decoration-thickness: 3px;
  padding: 0 0.2em;
  white-space: nowrap;
}

.sellalong-money {
  white-space: nowrap;
}
